
export default function Privacy() {
  return (
    <div>
      <h1>Privacy Statement</h1>
    </div>
  );
}
